import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as colorHelpersStyles } from '../../../assets/color-helpers.scss';
import { styles as styleHelpers } from '../../../assets/style-helpers.scss';

export const templateGenericGridSmartViews = document.createElement('template');

templateGenericGridSmartViews.innerHTML = `
    <style>${colorHelpersStyles}</style>
    <style>${commonStyles}</style>
    <style>${styleHelpers}</style>
    <style>${styles}</style>
    <div class="wrapper">
        <div class="content">
        <gz-generic-smart-views-list id="genericSmartViewsList"></gz-generic-smart-views-list>
        </div>
              <div class="loader">
                <gz-loader rows="4" class="smartview-loader"></gz-loader>
            </div>
    </div>

`;
